import React from 'react';
import { company, fairUseRules, refundSteps } from '../data/company';
import { ButtonLink } from './ButtonLink';
import { Card, CardFoot, CardTag } from './Card';
import { RichList } from './RichList';
import { Section } from './Section';
export function RefundsSection() {
  return <Section id="reembolsos" number="06" title="Política de reembolsos, cancelaciones y devoluciones" subtitle="Esta es la política vigente de Massive Faith LLC y se aplica a **todas** las compras hechas en cualquiera de nuestras tiendas, sin excepción." data-id="element-97" data-mp="2fvr32rbaj6m">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-98" data-mp="q56j9vulj595">
        <Card highlighted data-id="element-99" data-mp="q4oiqn0wi4vf">
          <CardTag data-id="element-100" data-mp="q2u57trylf1d">Garantía</CardTag>
          <h3 className="mb-3 text-[19px] font-bold tracking-[-0.01em] text-fg" data-id="element-101" data-mp="l5u0bm6uiibu">Garantía de satisfacción de 30 días</h3>
          <div className="space-y-3.5 leading-relaxed text-body" data-id="element-102" data-mp="2rxcn4zpa6ycs">
            <p data-id="element-103" data-mp="2mxzz4bmobl8m">
              Todos nuestros productos tienen una <strong className="font-bold text-fg" data-id="element-104" data-mp="2mzb76nn5jf5j">garantía de satisfacción de 30 días corridos</strong> desde la
              fecha de compra.
            </p>
            <p data-id="element-105" data-mp="1dhc59eq2nvdv">
              Si dentro de ese plazo el material no cumple tus expectativas, te devolvemos el{' '}
              <strong className="font-bold text-fg" data-id="element-106" data-mp="1hixij16iqbol">100 % del importe pagado</strong>.
            </p>
            <p data-id="element-107" data-mp="1mb8p2mvrkvq4">Pasados los 30 días no hacemos reembolsos, porque se trata de contenido digital de acceso inmediato y descarga permanente.</p>
          </div>
        </Card>
        <Card data-id="element-108" data-mp="1w83m11ce2o2a">
          <CardTag data-id="element-109" data-mp="1w7k8rxxoonul">Procedimiento</CardTag>
          <h3 className="mb-3 text-[19px] font-bold tracking-[-0.01em] text-fg" data-id="element-110" data-mp="1wapssyrggzjg">Cómo pedir un reembolso</h3>
          <RichList items={refundSteps} ordered className="text-[14.5px]" data-id="element-111" data-mp="215vd5t57m65f" />
          <CardFoot data-id="element-112" data-mp="258ibmcwdypbl">Al hacer el reembolso se desactivan los enlaces de descarga y se revoca la licencia de uso del material.</CardFoot>
          <div className="mt-3.5" data-id="element-113" data-mp="av0m4kcf7idx">
            <ButtonLink href={company.refundMailto} size="sm" data-id="element-114" data-mp="awbs8qtc9287">
              Pedir un reembolso
            </ButtonLink>
          </div>
        </Card>
      </div>

      <div className="mt-4 max-w-[860px]" data-id="element-115" data-mp="197cwehv5qwk6">
        <h3 className="mb-2 mt-7 text-[19px] font-bold tracking-[-0.01em] text-fg" data-id="element-116" data-mp="198eirihmj5h7">Cancelaciones</h3>
        <p className="leading-relaxed text-body" data-id="element-117" data-mp="1n7nrxy7ewzbo">
          Nuestros productos no son suscripciones:{' '}
          <strong className="font-bold text-fg" data-id="element-118" data-mp="1j3pr9j2fvggi">
            no hay cobros recurrentes, membresías con renovación automática ni pruebas gratuitas que se conviertan en un cargo
          </strong>
          , así que el cliente no tiene nada que cancelar para evitar cobros futuros. Cada compra es un pago único e independiente.
        </p>
        <h3 className="mb-2 mt-7 text-[19px] font-bold tracking-[-0.01em] text-fg" data-id="element-119" data-mp="21vs8owmwn0rt">Devoluciones de productos físicos</h3>
        <p className="leading-relaxed text-body" data-id="element-120" data-mp="2fv0ck2u0ix2c">
          No aplica. Massive Faith LLC no vende productos físicos, así que no hay devoluciones de mercadería, logística inversa ni gastos de reenvío.
        </p>
        <h3 className="mb-2 mt-7 text-[19px] font-bold tracking-[-0.01em] text-fg" data-id="element-121" data-mp="2uja4nor0qj3y">Condiciones de uso razonable</h3>
        <RichList items={fairUseRules} data-id="element-122" data-mp="2zg0magih1mrh" />
      </div>
    </Section>;
}